import React, { useEffect, useRef } from 'react';
import './VideoThumbnail.css';

/**
 * Miniature vidéo : charge les métadonnées et affiche la première image centrée.
 */
const VideoThumbnail = ({ src, className = '' }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !src) return undefined;

    const paintFirstFrame = () => {
      try {
        if (video.currentTime === 0) {
          video.currentTime = 0.01;
        }
      } catch {
        // Certains navigateurs bloquent le seek avant chargement complet
      }
    };

    video.addEventListener('loadeddata', paintFirstFrame);
    return () => video.removeEventListener('loadeddata', paintFirstFrame);
  }, [src]);

  if (!src) return null;

  return (
    <div className={`video-thumbnail ${className}`.trim()}>
      <video
        ref={videoRef}
        src={src}
        className="video-thumbnail__media"
        muted
        playsInline
        preload="metadata"
      />
    </div>
  );
};

export default VideoThumbnail;
